import ClassicQuizBasicModel from "./ClassicQuizBasicModel";
import ClassicQuizQuestionModel from "./ClassicQuizQuestionModel";

export default class ClassicQuizFullModel extends ClassicQuizBasicModel {
  public rules: string = null;
  public questions: ClassicQuizQuestionModel[] = [];
}
